export const RETRYABLE_DELAY_INITIAL_TIME = 2 * 1000;
export const RETRYABLE_DELAY_MAX_TIME = 5 * 60 * 1000;
export const RETRYABLE_DELAY_JITTER = true;
export const RETRYABLE_RETRY_MAX_TIME_COM = Infinity;
export const RETRYABLE_RETRY_MAX_TIME_OTHERS = 2 * 60 * 1000;

export const EVENT_SOURCE_CONNECTING_ERRORS_ALLOWANCE = 2;

export const HEARTBEAT_DEFAULT_TIMEOUT = 60 * 60 * 1000;
export const HEARTBEAT_CHECK_INTERVAL = 60 * 1000;
export const HEARTBEAT_CHECK_MISS_ALLOWANCE = 2;
